import React from "react";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";
import { Images } from "../../../assets/images";
import { H2 } from "./Styles";

const advantages = [
  {
    title: "Independent",
    desc: "IAMC is not an agent of any of the disputing parties. It aims to deliver dispassionate settlements in the most convenient way.",
    img: Images.independent,
  },
  {
    title: "Technology & AI",
    desc: "We use technology to make the process of resolution accessable and data driven insights to encourage parties to resolve faster to the benefit of all.",
    img: Images.technology,
  },
  {
    title: "Trained Resolution Experts",
    desc: "IAMC's resolution process is guided by a set of trained, empanelled and trusted experts. This provides both parties the best chance of getting a just resolution within the shortest time.",
    img: Images.professionals,
  },
  {
    title: "Enforceable Agreements & Awards",
    desc: "The outcome of a resolution on IAMC is a settlement agreement  or an arbitral award which is enforceable in a court of law.",
    img: Images.agreement,
  },
];

const OurAdvantages = () => {
  return (
    <Section>
      <H2
        style={{
          textAlign: "center",
          marginBottom: "50px",
        }}
      >
        Our Advantages
      </H2>
      <CardGrid>
        {advantages.map((adv, i) => (
          <Card key={i}>
            <ImageContainer>
              <Image src={adv.img} alt={adv.title} />
            </ImageContainer>
            <TextContent>
              <Heading>{adv.title}</Heading>
              <Description>{adv.desc}</Description>
            </TextContent>
          </Card>
        ))}
      </CardGrid>
    </Section>
  );
};

export default OurAdvantages;

const Section = styled.section`
  text-align: center;
  color: #293461;

  @media (max-width: 768px) {
    padding: 3rem 1rem;
  }
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  width: 90%;
  margin: 0 auto;
`;

export const Card = styled.div`
  border-radius: 1.2rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  text-align: left;
  display: flex;
  flex-direction: column;
  transition: transform 0.4s ease, box-shadow 0.4s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
  }
`;

export const ImageContainer = styled.div`
  height: 220px;
  overflow: hidden;
  position: relative;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;

  ${Card}:hover & {
    transform: scale(1.05);
  }
`;

export const TextContent = styled.div`
  padding: 1.8rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const Heading = styled.h3`
  font-size: 1.25rem;
  color: #00838c;
  font-weight: 600;
  margin: 0;
`;

const Description = styled.p`
  font-family: ${theme.fonts.primaryFontRegular};
  color: ${COLORS.COLOR_DARK};
  line-height: 1.6;
  font-size: 16px;
  margin: 0;
`;
